"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var newEditorModal = {
    title: "This page can't be opened :(",
    explainer: (react_1.default.createElement("p", null,
        "This page can't be opened because it was created using the new editor. If you have any questions please",
        " ",
        react_1.default.createElement(kaleidoscope_1.Link, { href: "mailto:help@qwilr.com" }, "contact our help team"))),
    buttonLabel: "Got it",
};
exports.default = newEditorModal;
